import { applyFilters, doRequest } from "./helpers";

export default class CampaignTargetEmailService {
  static async getForFilters(filters = null) {
    let path = "/email/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
